import { connect } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import FilterStack from './FilterStack';

import useFilter, {
  TEXT,
  EQUALS
} from 'app/hooks/useFilter';

// filter class (doesn't change)
const FILTER_CLASS = TEXT;

// filter type won't be changed for the select filter
const FILTER_TYPE = EQUALS;

const SelectFilterStack = props => {
  return (
    <FilterStack
      {...props}
      FilterComponent={SelectFilter}
      filterClass={FILTER_CLASS}
      defaultFilterType={FILTER_TYPE}
    />
  );
}

const SelectFilter = props => {
  const valueFormatter = event => event.target.value.toString();

  const {
    value,
    onChange
  } = useFilter({
    ...props,
    filterClass: FILTER_CLASS,
    filterType: FILTER_TYPE,
    valueFormatter
  });

  let inputProps = {
    disableUnderline: true,
    sx: {
      height: '100%',
      width: '100%',
      padding: '0 0.5rem',
      borderRadius: '2px !important'
    }
  }

  if (props.sx) {
    inputProps.sx = { ...inputProps.sx, ...props.sx };
  }

  if (!props.darkMode) {
    inputProps.sx.backgroundColor = '#fff !important';
  }

  const menuItems = props.column.colDef.inputOptions.map(({ label, value }) => {
    let key = `${props.column.colDef.field}-${label}-${value}`;
    return <MenuItem key={key} value={value}>{label}</MenuItem>;
  });

  // undefined isn't allowed as a value
  let defaultValue = value === undefined ? '' : value;
  
  return (
    <Select
      variant="filled"
      size="small"
      onChange={onChange}
      defaultValue={defaultValue}
      {...inputProps}
    >
      {menuItems}
    </Select>
  );
}

const mapStateToProps = state => ({
  darkMode: state.portalReducer.darkMode
});

export default connect(mapStateToProps)(SelectFilterStack);
